exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".vehicleInquiryBox {\n  width: 100vw;\n  height: 100%;\n  min-height: 100vh;\n  background: #fff;\n  position: relative;\n}\n.vehicleInquiryBox .registerBox .registerTitle {\n  width: 100%;\n  height: 1.7rem;\n  background: url(" + require("./images/bg.png") + ") no-repeat;\n  background-size: cover;\n}\n.vehicleInquiryBox .registerBox .registerText {\n  color: #333;\n  font-size: 0.15rem;\n  font-weight: 500;\n  margin-left: 0.15rem;\n}\n.vehicleInquiryBox .reward_3_row {\n  background-color: #009f90;\n  color: #fff;\n  font-size: 16px;\n  text-align: center;\n  width: 100%;\n  height: 0.44rem;\n  line-height: 0.44rem;\n  border-radius: 0.04rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/vehicleInquiry/index/index.less
// module id = 1587
// module chunks = 0